import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { PHONE, PHONE_LINK, WHATSAPP_LINK } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

export default function CTABand() {
  return (
    <section data-testid="cta-band" className="bg-brand-ink py-20 text-white md:py-24">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-10 px-6"
      >
        <div className="max-w-xl">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#E8C4B0]">
            Still Deciding?
          </p>
          <h2 className="mt-4 font-serif text-3xl font-light leading-tight tracking-tight md:text-5xl">
            Talk to a counsellor — <em className="italic text-[#E8C4B0]">free, honest, no obligations</em>.
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-white/60 md:text-base">
            Admissions are open for the 2026–27 batch and seats in each program
            are limited. One call is all it takes to plan your hospitality career.
          </p>
        </div>
        <div className="flex flex-col gap-4 sm:flex-row lg:flex-col xl:flex-row">
          <a
            data-testid="cta-band-call-button"
            href={PHONE_LINK}
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-brand-ink transition-colors duration-300 hover:bg-[#E8C4B0]"
          >
            <Phone className="h-4 w-4" />
            Call {PHONE}
          </a>
          <a
            data-testid="cta-band-whatsapp-button"
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:border-white hover:bg-white hover:text-brand-ink"
          >
            <MessageCircle className="h-4 w-4" />
            WhatsApp Counsellor
          </a>
        </div>
      </motion.div>
    </section>
  );
}
